module.exports = __webpack_public_path__ + "img/artist.be5030ca.webp";